import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';

export default function RHFCheckbox({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, onBlur, value, ref } }) => (
                <Checkbox checked={value} onChange={onChange} onBlur={onBlur} ref={ref} {...other} />
            )}
        />
    );
}

RHFCheckbox.propTypes = {
    name: PropTypes.string,
};
